import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PlaceholderTestTutorial from './PlaceholderTestTutorial';
import MarketOrdersTutorial from './MarketOrdersTutorial';
import * as firebase from 'firebase';

//receives sessionid and uid props from simulationContainer

//this component acts as the simulationContainer for all
//components in the actual orderbook.

const quips = ["Calling in favors...", "I hear the pound just went down against the dollar...","Trade tariffs or summat...", "Betting against USD...", "On the phone with the SEC..."]
  // Agricola:    (Lucas likes cows)
  //"I'll trade you a cow for 2 gold...", "Well, I'll trade you 2 cows for 4 sheep...", "I mean, we all know cows are the best resource; they're worth more than either farmland squares or pastures ...", "Well then I'll trade you 4 sheep for the 2 US dollars instead...",
  // Monty Python:
  /* "Lol heres some more text...", "Paying for the Spanish Inquisition...", "Come back here and fight like a Man! ...",  "I'll bite your legs off! ...",  "WE are the knights who say \"Ni\" ! ...",*/
  // The inimitible "All Star", by Smash Mouth:
   //"SomeBODY once told me the WORLD was gonna roll me ...", "Well, the years start coming and they don't stop coming, something something to the rules, and I hit the ground RUNnin ...", "Didn't make sense not to live for fun ...", "Your brain gets smart but your head gets duuuumb ...",  "So much to DO, so much to SEE, so what's WRONG with taaaaking the BACK streets? ...",  "You never shine if you don't glow ...", "Hey now, you're an All Star ...",  "Get the GAME on, GO... PLAYYY ...", /*I'm missing some lyrics here; fill em in if you remember 'em / take the time to (TODO) Google 'em*/ "And ALLLLlll that glitters is goooold ...", "Only shooting staaars, break the mooowuOLD ..."];    
  // these quips used to say  "Misplaced your cash...", and "embezzling funds" before Bruce wanted it out for being too unprofessional.  In fairness, I agree. If a prof sees "Embezzling Funds" in the software they paid for, it's a little sketch.  We can debate it at the next meeting.  -Nathan Bendich, August 14, 2022,
class OrderbookContainerTutorial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      // midPoints: [],
      paused: true,
      quip:quips[Math.floor(Math.random()*quips.length)],

    };
  }

  //sets quip state to display quips on a timer
  getQuip() {
    this.setState({
      quip: quips[Math.floor(Math.random()*quips.length)]
    })
  }

  componentDidMount() {
    this.aggobRef = firebase.database().ref().child("Session2").child("Assets").child("INTC").child("AggOB");
    this.middlePointRef = firebase.database().ref().child("Session2").child("ImportantData").child("SessionData");
    this.pausedRef = firebase.database().ref().child("Session2").child('StartSim').child('State');

    //declares quip automation timer
    this.quipsTimer = setInterval(this.getQuip.bind(this),5000);

    var strike, bid, ask;

    //this listener deals with determining if the sim is paused
    this.pausedRef.on('value', snap => {
      let rawData = snap.val();
      if (rawData === "Running") {
        this.setState({
          paused: false
        });
      } else if (rawData === "Paused" || rawData === "Over") {
        this.setState({
          paused: true
        });
      }
    })

    //this listener deals with checking the middle bid
    //and ask points
    // this.middlePointRef.on('value', snap => {
    //   let rawData = snap.val();
    //   if (!!rawData) {
    //     var midPoints = [];
    //     //let midPoints = [];
    //     //console.log(rawData);
    //     midAsk = rawData.ask;
    //     midBid = rawData.bid;
    //     midPoints.push({
    //       midAsk: midAsk,
    //       midBid: midBid
    //     });
    //     //console.log(midAsk,midBid);
    //     this.setState({
    //       midPoints: midPoints
    //     });
    //   }
    // })

    //this listener deals with getting current strikes, bid,
    //and ask. Also deals with setting ready state
    this.aggobRef.on('value', snap => {
      let rawData = snap.val();
      if (rawData) {
        //console.log(rawData);
        var ords = [];
        for (var key in rawData) {
          //rawStrike = key;
          strike = (key / 100).toFixed(2);
          bid = rawData[key].Bid;
          if (bid === undefined) {
            bid = 0;
          }
          ask = rawData[key].Ask;
          if (ask === undefined) {
            ask = 0;
          }
          if (bid === 0) {
            bid = "";
          }
          if (ask === 0) {
            ask = "";
          }
          ords.push({
            "Strike": strike,
            "Bid": bid,
            "Ask": ask
          });
        }
        this.setState({
          orders: ords.reverse(),
          ready: true
        });
      } else {
        //var ords = [];
        this.setState({
          orders: ords,
          ready: false
        });
      }
    })


  }

  componentWillUnmount() {
    clearInterval(this.quipsTimer);
    this.aggobRef.off();
    this.middlePointRef.off();
    this.pausedRef.off();
  }

  render() {
    return (
      <div id='PlaceOrder'>
          <div id='orderBookTableStyle'>
          <MarketOrdersTutorial institution={this.props.institution} paused={this.state.paused} uid={this.props.uid} />
          <div className='row text-center'>
            <div className='col-xs-3'>Limit Bid</div>
            <div className='col-xs-2'>Bids</div>
            <div className='col-xs-2'>Strike</div>
            <div className='col-xs-2'>Asks</div>
            <div className='col-xs-3'>Limit Ask</div>
          </div>
        </div>
        {
          this.state.ready
          //conditionally renders limit orders based on state.ready
          ? <div className='row text-center'>
              {this.state.orders.map(function(ord, index){
                return(
                  <div key={ord.toString()+index}>
                    <PlaceholderTestTutorial institution={this.props.institution} paused={this.state.paused} key={ord.toString()} uid={this.props.uid} Bid={ord.Bid}
                    Strike={ord.Strike} Ask={ord.Ask} /*midPoints={this.state.midPoints}*/ />
                  </div>
                );
              }.bind(this))}
            </div>
          : <div style={{'position':'absolute','top':'40%','left':'25%','fontSize':'26px'}}>{this.state.quip}</div>
        }
      </div>
    );
  }
}

OrderbookContainerTutorial.propTypes = {
  sessionid: PropTypes.string,
  uid: PropTypes.string
};

export default OrderbookContainerTutorial;



// WEBPACK FOOTER //
// ./src/components/OrderbookTutorial/OrderbookContainerTutorial.js